import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import {   defaultDropList } from "../Data/WBComponentDefaults";
import React from "react";

import { AttributeDefinition, AttributeInputType, CreateConditionalAttribute } from "../Data/WBData";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import WebDesigner from "../WebDesigner";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";

import MissingSourceDisplay from "vagaro-website-rendering/src/components/MissingSourceDisplay";
import CreateAttributeList, { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { GetNodeComponenentAttributeBinding, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import RenderVideoPlayer from "vagaro-website-rendering/src/components/ComponentRenders/RenderVideoPlayer";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";
// Create a styled div for the player wrapper

export default class WBVideoPlayer extends WBComponent {

    constructor(){

        let list = CreateAttributeList(true,false,true,true,false);
        list = list.filter(a=>a!=attributeTypes.clipPath);

        super();
        this.typename =wBComponentTypeNames.videoPlayer;
        this.displayName = "Video";
        this.dropList = defaultDropList;
        this.editList = ["thumbnail","videoSrc", "videoStyles","vCardTitle","vCardSubtitle", "vCardDesc", "conditionalThumbnail", "autoPlay","videoFit","videoControls","loop","conditionalAutoPlay","conditionalVidTextColor","vCardTextColor","conditionalVideoFit","conditionalControls","conditionalLoop",...list];
        this.primaryEditAttributes = ["videoSrc", "videoStyles", "conditionalThumbnail", "conditionalVideoTitle", "conditionalVideoSubtitle", "conditionalVideoDescription", "conditionalVidTextColor","conditionalAutoPlay","conditionalVideoFit","conditionalControls","conditionalLoop"];
        this.contentEditable = false;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"> <path d="M48 416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V208H48V416zM336 160h64l64-64c0-8.8-7.2-16-16-16H416l-80 80zm-96 0l80-80H256l-80 80h64zM80 160l80-80H96L48 128v32H80zM512 96v64 24 24V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208 184 160 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64zM216.5 241.9c5.2-2.8 11.5-2.5 16.4 .8l96 64c4.4 3 7.1 8 7.1 13.3s-2.7 10.3-7.1 13.3l-96 64c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V256c0-5.9 3.2-11.3 8.5-14.1z"/></svg>
        this.cssDefinitions = [
            new NodeCSSClassDefinition(".video-text",
            [
                {key:"vCardTextColor",cssProperty:"color",default:""},
                
             ]),
        ]
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {

        const vSrc = new AttributeDefinition("videoSrc","Video Source","",AttributeInputType.InputFiled);
        const autoPlay = new AttributeDefinition("autoPlay","Auto Play","",AttributeInputType.ButtonField,[
            {label:"Off",value:"off"},{label:"On",value:"on"}
        ]);
        const videoFit = new AttributeDefinition("videoFit","Video Fit","",AttributeInputType.ButtonField,[
            {label:"Contain",value:""},{label:"Cover",value:"cover"}
        ]);
        const controls = new AttributeDefinition("videoControls","Video Controls","",AttributeInputType.ButtonField,[
            {label:"Hide",value:""},{label:"Show",value:"on"}
        ]);

        const loopAtt = new AttributeDefinition("loop","Loop","",AttributeInputType.ButtonField,[
            {label:"Off",value:"off"},{label:"On",value:"on"}]);
        
        const videoCardTitle = new AttributeDefinition("vCardTitle","Card Title","",AttributeInputType.InputFiled);
        const videoCardSubtitle = new AttributeDefinition("vCardSubtitle","Card Subtitle","",AttributeInputType.InputFiled);
        const videoCardDesc = new AttributeDefinition("vCardDesc","Card Description","",AttributeInputType.EmojiField);

        const videoTextColor = new AttributeDefinition("vCardTextColor","Text Color","",AttributeInputType.ColorField);
        const videoStyles = new AttributeDefinition("videoStyles","Video Styles","",AttributeInputType.SelectField,[
            { label: "Default", value: "" },
            // { label: "Rounded Corners", value: "2" },
            { label: "Popup", value: "3" },
            { label: "Popup Card", value: "4" }

        ])

        const condAutoplay = CreateConditionalAttribute("conditionalAutoPlay", "autoPlay", [{ key: "videoStyles", value: "" }]);
        const condVideoFit = CreateConditionalAttribute("conditionalVideoFit", "videoFit", [{ key: "videoStyles", value: "" }]);
        const condControls = CreateConditionalAttribute("conditionalControls", "videoControls", [{ key: "videoStyles", value: "" }]);
        const condLoop = CreateConditionalAttribute("conditionalLoop", "loop", [{ key: "videoStyles", value: "" }]);
        const condTextColor = CreateConditionalAttribute("conditionalVidTextColor", "vCardTextColor", [{ key: "videoStyles", value: "4" }]);

        const condVideoTitle = CreateConditionalAttribute("conditionalVideoTitle", "vCardTitle", [{ key: "videoStyles", value: "4" }]);
        const condVideoSubTitle = CreateConditionalAttribute("conditionalVideoSubtitle", "vCardSubtitle", [{ key: "videoStyles", value: "4" }]);
        const condVideoDesc = CreateConditionalAttribute("conditionalVideoDescription", "vCardDesc", [{ key: "videoStyles", value: "4" }]);
        const maxRange = {min:0,unit:"",step:1, max: 40 };
        condVideoTitle.range = maxRange;
        condVideoSubTitle.range = maxRange;



        const imgDef = new AttributeDefinition("thumbnail","Video Thumbnail","",AttributeInputType.ImageField);
        const condImg = CreateConditionalAttribute("conditionalThumbnail", "thumbnail", [
            { key: "videoStyles", value: "3" }, // Popup video
            { key: "videoStyles", value: "4" } // Video card
          ]);
          
        

        vSrc.placeHolder = "https://";
        videoCardTitle.placeHolder = "Title";
        videoCardSubtitle.placeHolder = "Subtitle";
        videoCardDesc.placeHolder = "Description";
        return [
            vSrc,
            autoPlay,
            loopAtt,
            videoFit,
            controls,
            videoStyles,
            videoCardTitle,
            videoCardSubtitle,
            videoCardDesc,
            condVideoTitle,
            condVideoSubTitle,
            condVideoDesc,
            imgDef,
            condImg,
            condAutoplay,
            condVideoFit,
            condControls,
            condLoop,
            condTextColor,
            videoTextColor

        ];
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        thisLayout.screenSizeStyleAttributes[ScreenSize.Desktop] = {width:"500px",height:"500px"};
       setNodeComponentAttributeValue(thisLayout,"videoControls","on");
    }
    
    RenderLayout({component,children,screenSize,isEditor}:WBRenderProps)
     {
        const videoFit = getNodeComponentAttributeValue(component,"videoFit","");
        const vStyle = (videoFit=="cover")?"video-cover ":"";
        const atts = GetNodeDomAttributes("v-iframe empty "+vStyle,component,screenSize,isEditor)
        let videoSource = getNodeComponentAttributeValue(component,"videoSrc","");

        if(videoSource==""){
            return (
                <div {...atts}>
                  <MissingSourceDisplay/>
                </div>
            )
        }

        if(!isEditor){

           return <><div {...atts}  {...GetNodeComponenentAttributeBinding(component,isEditor) }  ></div></>
        }
     
        return (

            <div {...atts}  {...GetNodeComponenentAttributeBinding(component,isEditor)} >
            <style>
             {super.GetComponentGlobalCSS(component, true)}
             </style>
            <RenderVideoPlayer component={component} />
            </div>
        )

    }

}